<template>
	<div class="app-wrapper">
		<sidebar class="sidebar-container"></sidebar>
		<div class="main-container">
			<navbar class="left-nav"></navbar>
			<app-main class="right-content"></app-main>
		</div>
	</div>
</template>

<script>
	import Sidebar from './sidebar.vue'
	import Navbar from './navbar.vue'
	import AppMain from './appMain.vue'
	// import { Navbar, Sidebar, AppMain } from '../../views/layout/components'
	export default {
		name: 'layout',
		components: {
			Navbar,
			Sidebar,
			AppMain
		},
		// computed: {
		//   sidebar() {
		//     return this.$store.state.app.sidebar
		//   }
		// }
	}
</script>
<style lang="scss">
	.app-wrapper {
		flex: 1;
		height: 100vh;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		overflow: hidden;

		.sidebar-container {}

		.main-container {
			flex: 1;
			width: 100%;
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: center;

			.left-nav {
				width: 222px;
				height: calc(100vh - 70px);
				background-color: #ffffff;
				overflow-x: hidden;
			}

			// .left-nav::-webkit-scrollbar{
			// display: none;//隐藏滚动条
			// }
			.right-content {
				flex: 1;
				height: calc(100vh - 70px);
				overflow-y: auto;
			}
		}
	}
</style>